import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AvAvatarComponent } from '../av-avatar/av-avatar.component';
import { AuthService } from '../../Services/auth.service';
import { OperatorFacade } from '../../../../Facades/operator.facade';

@Component({
  selector: 'av-header',
  standalone: true,
  imports: [MatIconModule, MatToolbarModule, MatTooltipModule, AvAvatarComponent, TranslatePipe],
  templateUrl: './av-header.component.html',
  styleUrl: './av-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvHeaderComponent {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);
  private readonly _authService = inject(AuthService);

  readonly operatorFacade = inject(OperatorFacade);

  private readonly _currentUrl = toSignal(
    this._router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this._router.url),
    ),
  );

  readonly pageTitle = computed<string>(() => {
    this._currentUrl();

    return this._deepestTitle() ?? 'backoffice.shell.title';
  });

  logout(): void {
    this._authService.logout();
  }

  private _deepestTitle(): string | null {
    let snapshot: ActivatedRouteSnapshot = this._route.snapshot;

    while (snapshot.firstChild) {
      snapshot = snapshot.firstChild;
    }

    return snapshot.title ?? null;
  }
}
